import focusWithin from 'focus-within';
import { $, $$, $id, addEventListenerAll } from '../helper/utils';
import { searchTween } from './search/tween';
import { headerSearch } from './search/headerSearch';
import { loginTween } from './navigation/tweens';
import navigation from './navigation/desktop';

const mobileNav = $('.mobile-nav');
const showmenu = $('.show-menu');
const showsearch = $('.nav-search');
const showlogin = $$('.show-login');
const ssoWrapper = $('.sso-wrapper');
const searchTl = searchTween();
const isIOS = document.documentElement.classList.contains('ios');
const viewState = {
    menu: 'closed',
    search: 'closed',
};
let bodyScrollLock;

focusWithin(document);
navigation();

if (isIOS === true) {
    import('body-scroll-lock')
        .then((resp) => {
            bodyScrollLock = resp;
        });
} else {
    bodyScrollLock = {};
}

const langSelect = $$('.lang-select > button');

addEventListenerAll(langSelect, 'click', function () {
    this.parentElement.classList.toggle('open');
}, { passive: true });

function hideLang() {
    this.classList.remove('open');
}

window.addEventListener('click', (e) => {
    for (let i = 0; i < langSelect.length; i++) {
        const el = langSelect[i].parentElement;
        if (e.target !== el && el.contains(e.target) === false) {
            hideLang.call(el);
        }
    }
});

// for (let i = 0; i < langSelect.length; i++) {
//     const el = langSelect[i].parentElement;
//     el.addEventListener('focusout', hideLang);
// }

export default () => {
    // mainMenuTween.progress(1).progress(0);

    // showmenu.addEventListener('click', () => {
    //     if (menuTween.progress() > 0) {
    //         document.documentElement.classList.remove('noscroll');
    //         requestAnimationFrame(() => {
    //             menuTween.reverse();
    //         });

    //         requestAnimationFrame(() => {
    //             if (viewState.search === 'open') {
    //                 viewState.search = 'closed';
    //                 searchTl.timeScale(1.75).reverse();
    //             } else {
    //                 viewState.menu = 'closed';
    //                 btnTween.timeScale(2).reverse();
    //                 mainMenuTween.timeScale(1.25).reverse();
    //             }
    //         });
    //     } else {
    //         document.documentElement.classList.add('noscroll');
    //         viewState.menu = 'open';
    //         requestAnimationFrame(() => {
    //             menuTween.play();
    //             mainMenuTween.timeScale(1).play();

    //             // delay animation
    //             setTimeout(() => {
    //                 btnTween.timeScale(1).play();
    //             }, mainMenuTween.totalDuration() * 0.05);
    //         });
    //     }
    // }, { passive: true });

    showsearch.addEventListener('click', () => {
        if (viewState.search !== 'open') {
            document.documentElement.classList.add('noscroll');

            if (isIOS === true) {
                bodyScrollLock.enableBodyScroll && bodyScrollLock.disableBodyScroll(mobileNav); // eslint-disable-line
            }

            headerSearch();
            requestAnimationFrame(() => {
                viewState.search = 'open';
                searchTl.play();
                TweenMax.to(showmenu, 0.225, { autoAlpha: 0, ease: Sine.easeOut });
                // menuTween.play();
                // // if menu is currently open, close it first
                // if (viewState.menu === 'open') {
                //     mainMenuTween.reverse();
                //     btnTween.timeScale(2).reverse();
                //     viewState.menu = false;
                //     setTimeout(() => {
                //         searchTl.play();
                //     }, mainMenuTween.totalDuration() * 1.25 * 1000);
                // } else {
                // }
            });
        } else {
            document.documentElement.classList.remove('noscroll');

            if (isIOS === true) {
                bodyScrollLock.enableBodyScroll && bodyScrollLock.enableBodyScroll(mobileNav); // eslint-disable-line
            }

            viewState.search = 'closed';
            searchTl.timeScale(1.75).reverse();
            TweenMax.set(showmenu, { clearProps: 'all', delay: 0.6 });
        }
    }, { passive: true });

    if (showlogin.length > 0) {
        for (let i = 0; i < showlogin.length; i++) {
            showlogin[i].addEventListener('click', function () {
                if (this.getAttribute('data-redirect')) {
                    $id('login-form').setAttribute('data-url', this.getAttribute('data-redirect'));
                }
                document.documentElement.classList.add('noscroll');
                requestAnimationFrame(() => {
                    loginTween.play();
                });
            }, { passive: true });
        }

        ssoWrapper.addEventListener('click', (e) => {
            if (e.target.classList.contains('backdrop') || e.target.classList.contains('close-btn')) {
                if (viewState.menu === 'closed' && viewState.search === 'closed') {
                    document.documentElement.classList.remove('noscroll');
                }

                requestAnimationFrame(() => {
                    loginTween.reverse();
                });
            }
        }, { passive: true });
    }
};
